// extracted by mini-css-extract-plugin
export default {"inputWrap":"ResetPassword_inputWrap__mxQYE"};